import { PurposeType } from '../../../../proto/generated/company_event'
import { purposeTypeMap } from '../../../../assets/constants'

const eventMapping: { [key: string]: { letter: string; color: string } } = {
    dividend: { letter: 'D', color: '#0f89e5' },
    split: { letter: 'S', color: 'rgb(251, 140, 0)' },
    bonus: { letter: 'B', color: '#B8860B' },
    default: { letter: 'E', color: 'skyblue' },
}

export function getCompanyEventLetter(purposes: string[]): string {
    const priorityOrder = ['dividend', 'split', 'bonus', 'default']
    for (const priority of priorityOrder) {
        if (purposes.includes(priority)) {
            return eventMapping[priority].letter
        }
    }
    return 'E'
}

export function getCompanyEventColor(purposes: string[]): string {
    const priorityOrder = ['dividend', 'split', 'bonus', 'default']
    for (const priority of priorityOrder) {
        if (purposes.includes(priority)) {
            return eventMapping[priority].color
        }
    }
    return 'skyblue'
}

export function getCompanyEventPurposeDisplayName(code: string | number): string {
    if (typeof code === 'number') {
        const enumKey = Object.keys(PurposeType).find(
            key => PurposeType[key as keyof typeof PurposeType] === code,
        )
        if (enumKey) {
            return purposeTypeMap[enumKey] || 'Unknown'
        }
    }
    if (typeof code === 'string' && purposeTypeMap[code]) {
        return purposeTypeMap[code]
    }
    return 'Unknown'
}
